module.exports = __webpack_public_path__ + "img/rightBox1.aa93e047.png";